import $ from "jquery";

const $window = $(window);
const $header = $(".header");

export function isInt(n) {
  return Number(n) === n && n % 1 === 0;
}

export function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}

export function getScrollBarWidth() {
  const $outerEl = $("<div>")
    .css({
      visibility: "hidden",
      width: 100,
      overflow: "scroll",
    })
    .appendTo("body");
  const widthWithScroll = $("<div>")
    .css({
      width: "100%",
    })
    .appendTo($outerEl)
    .outerWidth();
  $outerEl.remove();

  return 100 - widthWithScroll;
}

export function getWindowWidth() {
  return $window.width() - getScrollBarWidth();
}

export function getHeaderHeight() {
  return $header.outerHeight();
}

export function getVh() {
  return window.innerHeight * 0.01;
}

export function debounce(
  callback,
  execOnLeadingEdge = false,
  debounceDelay = 200
) {
  let timeout;

  return function debounced() {
    let obj = this;
    let args = arguments;

    function delayed() {
      if (!execOnLeadingEdge) {
        callback.apply(obj, args);
      }
      timeout = null;
    }

    if (timeout) {
      clearTimeout(timeout);
    } else if (execOnLeadingEdge) {
      callback.apply(obj, args);
    }

    timeout = setTimeout(delayed, debounceDelay);
  };
}

export function flipSign(n) {
  if (isInt(n) || isFloat(n)) {
    return -1 * n;
  }
}

export function trim(str, char) {
  let start = 0;
  let end = str.length;

  while (start < end && str[start] === char) ++start;
  while (end > start && str[end - 1] === char) --end;

  return start > 0 || end < str.length ? str.substring(start, end) : str;
}

export function getVideoId(rawUrl) {
  const url = new URL(rawUrl);
  let slug = false;

  if (url.search) {
    if (url.searchParams.get("v")) {
      slug = url.searchParams.get("v");
    } else if (url.searchParams.get("vi")) {
      slug = url.searchParams.get("vi");
    }
  }
  if (url.pathname && slug === false) {
    const path = trim(url.pathname, "/").split("/");
    slug = path[path.length - 1];
  }

  return slug;
}

export function isOverflown(element) {
  return isVerticalOverflown(element) || isHorizontalOverflown(element);
}

export function isVerticalOverflown(element) {
  return element.scrollHeight > element.clientHeight;
}

export function isHorizontalOverflown(element) {
  return element.scrollWidth > element.clientWidth;
}
